'use strict'

class StationSettingsMetadataradioNowOnAirCtrl {
    constructor ($rootScope, $http, $mdToast, $scope, $mdDialog) {
        this.$http = $http
        this.$mdToast = $mdToast
        this.$rootScope = $rootScope
        this.$scope = $scope
        this.$mdDialog = $mdDialog

        this.$rootScope.saveDisabled = false
        this.$rootScope.saveHiden = false
        this.$rootScope.save = this.save.bind(this)

        $scope.$watch(() => {
            return $scope.metadataradioform.$invalid
        }, (newVal) => {
            $rootScope.saveDisabled = newVal
        })

        this.exportData = {
            metadataradio: {}
        }

        $rootScope.saveSettings = () => {
            this.save()
        }

        this.fetch()
    }

    fetch () {
        this.$http.get('/stationsettings/export/metadataradio').then(response => {

            this.exportData = response.data

        })

    }

    save () {
        this.$rootScope.saveDisabled = true
        this.$http.put('/stationsettings/export', this.exportData).then(() => {

            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.object_saved?object=metadata_radio', //@trans('labels.Export')
                hideDelay: 6000,
                position: ('top right')
            })

            this.$rootScope.saveDisabled = false
        })
    }

    checkLastSyncTime () {
        if (this.exportData.metadataradio.lastSync) {
            let lastSync = moment(this.exportData.metadataradio.lastSync)
            let now = moment()
            if (now.subtract('hour', 1) < lastSync) {
                return false
            }
        }
        return true
    }

    showLastSyncTime () {
        if (this.exportData.metadataradio.lastSync) {
            let lastSync = moment(this.exportData.metadataradio.lastSync)
            let now = moment()
            if (now.subtract('days', 1) < lastSync) {
                return moment(this.exportData.metadataradio.lastSync).format('HH:mm')
            }
        }
        return false
    }
}

StationSettingsMetadataradioNowOnAirCtrl.$inject = ['$rootScope', '$http', '$mdToast', '$scope', '$mdDialog']

module.exports = StationSettingsMetadataradioNowOnAirCtrl
